import React from 'react'
import loadImage from 'image-promise';
import cubicInOut from 'eases/cubic-in-out';
import animate from '../utils/animate';
import wait from '../utils/wait';
import hintImg from '../images/360.svg'
import Img from 'gatsby-image'

let Impetus;

if (typeof window !== `undefined`) {
  Impetus = require('impetus');
}

export default class ThreeSixtCatalog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 7,
      loading: true,
      hasSpinned: false,
      isHovered: false,
      frames: [],
    };
  }

  componentWillMount() {
    if (typeof window === `undefined`) {
      return;
    }
    this._ismounted = true

    const { product, timeout } = this.props;
    const { collection } = product;
    const frames = collection.threesixty.frames

    const firstFrameSrc =  frames[0].normal.src
    const adjustedFrames = firstFrameSrc.includes("_01") ?
      collection.threesixty.frames.reverse() :
      collection.threesixty.frames

    const selectedFrames = adjustedFrames.map(f => (
      f[collection.threesixty.isTall ? 'tall' : 'normal'].src
    ))

    this.setState({ frames: selectedFrames });

    Promise.all([
      wait(timeout),
      loadImage(selectedFrames)
      .then(() => {
        this.setState({ loading: false });
      })
      .catch(errr => (console.error(errr))  )
    ])
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  onMouseEnterHandler() {
    if (!this.state.loading && !this.state.hasSpinned) {
      wait(100)
      .then(() => {
        animate(7, 57, 2000, cubicInOut, (frame) => {
          this.setCurrentFrame(Math.floor(frame));
        });
      })
      .then(() => {
        this.setState({ hasSpinned: true });
      })
      .catch(errr => (console.error(errr))  )
    }
  }

  handleHover(){
    this.setState({
      isHovered: !this.state.isHovered
    });
  }


  setCurrentFrame(frame) {
    const { collection } = this.props;
    const { frames } = this.state;

    const length = frames.length
    let current = frame

    while (current < 0) {
      current = current + length
    }

    while (current > length - 1) {
      current = current - length
    }


    if (current !== this.state.current) {
      this.setState({ current })
    }
  }

  render() {
    const { product } = this.props;
    const { collection } = product;
    const { loading, current, isHovered, frames } = this.state;
    return (
      <div className="catalog__item" key= {collection.color.hex}
        style={{backgroundColor: `${isHovered ? collection.color.hex : 'transparent'}`}}
      >
        <div className="catalog__item__title">
          {product.title}
        </div>
        <div className="threesixty--catalog"
          ref={(el) => this.container = el}
          onMouseEnter={() => {
            this.onMouseEnterHandler();
            this.handleHover();
          }}
          onMouseLeave={() => this.handleHover()}
          >
          {
            product.showThreesixty ?
              <div>
                {
                  frames.map((frame, i) =>
                    <img className={`threesixty--catalog__image ${i === current ? "" : "hidden"}`}
                      src={frame} key={i}
                    />
                  )
                }
                {
                  loading &&
                    <div className="threesixty__loading">
                      <div className="threesixty__loading__rect1"></div>
                      <div className="threesixty__loading__rect2"></div>
                      <div className="threesixty__loading__rect3"></div>
                      <div className="threesixty__loading__rect4"></div>
                      <div className="threesixty__loading__rect5"></div>
                    </div>
                }
              </div> :
              <img src={product.image.sizes.src} key={product.image.src} />
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ThreeSixtyCatalog.js